<template>
  <v-container fill-height>
    <v-row align-center justify-center>
      <v-col cols="12" sm="4" class="grey--text text-center mx-auto">
        <h1 class="display-1">404</h1>
        <p class="subheading">🤔 Hm, the page you were looking for doesn't seem to exist anymore.</p>
        <v-btn to="/" rounded outlined color="primary" class="mb-5">Back to</v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    //
  })
}
</script>
